export default "__VITE_ASSET__BastM7bV__"